import { useEffect, useState } from 'react'
import { Input } from 'antd'
import { QueryEditor } from 'Components'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import FormLikeField from './FormLikeField'
import AceEditor from 'react-ace'
import "ace-builds/src-noconflict/mode-perl"
import "ace-builds/src-noconflict/theme-solarized_light"
import "ace-builds/src-noconflict/theme-solarized_dark"
import langTools from "ace-builds/src-noconflict/ext-language_tools"
import weaverQueryCompleter from 'Components/weaverQueryCompleter'

ace.config.set(
  "basePath",
  "https://cdn.jsdelivr.net/npm/ace-builds@1.4.3/src-noconflict/"
)

QueryConfig = ({ fieldKey }) ->

  [attrKeys, setAttrKeys] = useState([])
  [relKeys, setRelKeys] = useState([])
  [isLoading, setIsLoading] = useState(false)

  useEffect( ->
    ( ->
      setIsLoading(true)
      relKeyBindings = await new Weaver.Sparql("""
        SELECT DISTINCT ?key WHERE {
          ?s ?key ?o .
          FILTER(isIRI(?o))
        }
      """).find()
      setRelKeys(relKeyBindings.key.map(({ nodeId}) -> nodeId ))

      attrKeyBindings = await new Weaver.Sparql("""
        SELECT DISTINCT ?key WHERE {
          ?s ?key ?o .
          FILTER(isLiteral(?o))
        }
      """).find()
      setAttrKeys(attrKeyBindings.key.map(({ nodeId}) -> nodeId ))
      setIsLoading(false)
    )()
    undefined
  , [])

  darkModeEnabled = document.body.classList.contains('theme-dark')
  [{ fieldData }, dispatch] = useCreateMacroData()

  setDerivedData = (key) -> (value) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'derivedData', key], value)
      )
    )

  <>
    {
      if isLoading
        <div />
      else
        <AceEditor
          mode="perl"
          theme={darkModeEnabled && "solarized_dark" || "solarized_light"}
          fontSize={16}
          showGutter={true}
          highlightActiveLine={true}
          height="200px"
          value={fieldData[fieldKey]?.derivedData?.query}
          onChange={setDerivedData('query')}
          setOptions={{
            enableBasicAutocompletion: [weaverQueryCompleter(attrKeys, relKeys)]
            enableLiveAutocompletion: [weaverQueryCompleter(attrKeys, relKeys)],
            showLineNumbers: true,
            tabSize: 2,
          }}
          style={{ borderRadius: 6, marginBottom: 10, width: '100%' }}
        />
    }
      <FormLikeField label="Label to use for querying">
        <Input
          value={fieldData[fieldKey]?.derivedData?.labelAttr}
          placeholder="Name"
          onChange={({ target: { value }}) ->
            setDerivedData('labelAttr')(value)
          }
        />
      </FormLikeField>
  </>

export default QueryConfig
